import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSynchronizeArrowsSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "synchronize-arrows-square_icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7 21.75h10a1.25 1.25 0 0 0 0-2.5H7a1.76 1.76 0 0 1-1.75-1.75v-4.25A.25.25 0 0 1 5.5 13h1a.49.49 0 0 0 .5-.29.47.47 0 0 0-.07-.53l-2.5-3a.49.49 0 0 0-.76 0l-2.5 3a.47.47 0 0 0-.07.53.49.49 0 0 0 .4.29h1a.25.25 0 0 1 .25.25v4.25A4.26 4.26 0 0 0 7 21.75M20 15a.49.49 0 0 0 .38-.18l2.5-3a.47.47 0 0 0 .07-.53.49.49 0 0 0-.45-.29h-1a.25.25 0 0 1-.25-.25V6.5A4.25 4.25 0 0 0 17 2.25H7a1.25 1.25 0 0 0 0 2.5h10a1.75 1.75 0 0 1 1.75 1.75v4.25a.25.25 0 0 1-.25.25h-1a.49.49 0 0 0-.45.29.47.47 0 0 0 .07.53l2.5 3A.49.49 0 0 0 20 15" })
});
export { SvgSynchronizeArrowsSquare as ReactComponent };
